import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { motion as m } from 'framer-motion';

import MapExercise from './MapExercise';

const AddExercises = (props) => {
    const { exercises, addExercise, removeExercise, switchType, setExercises } = props;

    const handleSwitchType = (event) => {
        let value = event.split('-')[0];
        let index = event.split('-')[1];
        switchType({ index, value });
    }

    const updateName = (index, newName) => {
        // console.log(index);
        // console.log(newName);
        console.log(exercises[index].name);
        const exercisesCopy = exercises.slice();
        exercisesCopy[index].name = newName;
        setExercises(exercisesCopy);

        // setExercises(updatedEvents); // Update state
    }

    const handleChangeExerciseName = (event) => {
        const value = event.target.value;
        const index = event.target.name;
        // console.log(exercises);
        updateName(index, value);
        // let newExercises = [...exercises]
        // newExercises[index].name = value;
        // setExercises(newExercises);
    }

    const handleChangeExerciseReps = (event) => {
        let index = event.target.name.split('~')[1]
        let value = event.target.value;
        let newExercises = [...exercises]
        newExercises[index].reps = value;
        setExercises(newExercises);
    }

    const handleChangeExerciseTime = (event) => {
        let index = event.target.name.split('~')[1]
        let value = event.target.value;
        let newExercises = [...exercises]
        newExercises[index].time = value;
        // Clear distance when time is set
        if (value && value !== '') {
            newExercises[index].distance = null;
        }
        setExercises(newExercises);
    }

    const holderFunction = () => {
        setExercises(exercises)
    }

    const getTitle = (value) => {
        if (value === 'CV') {
            return 'Cardio'
        } else if (value === 'Weights') {
            return 'Lift'
        } else {
            return 'Time'
        }
    }

    const handleChangeDistance = (event) => {
        let index = event.target.name.split('~')[1]
        let value = event.target.value;
        let newExercises = [...exercises]
        newExercises[index].distance = value;
        // Clear time when distance is set
        if (value && value !== '') {
            newExercises[index].time = null;
        }
        setExercises(newExercises);
    }

    const handleChangeCVMode = (index, mode) => {
        let newExercises = [...exercises]
        if (mode === 'km') {
            // Set distance mode - clear time
            newExercises[index].time = null;
            newExercises[index].distance = newExercises[index].distance || '';
        } else if (mode === 'mins') {
            // Set time mode - clear distance
            newExercises[index].distance = null;
            newExercises[index].time = newExercises[index].time || '';
        }
        setExercises(newExercises);
    }

    return (
        <m.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.75, ease: 'easeOut' }}>
            <p>Please add the desired exercises to the event:</p>
            <Row style={{ marginBottom: '20px', color: '#26ffe2' }}>
                <Col xs={5}>Exercise</Col>
                <Col xs={2}>Type</Col>
                <Col xs={3}>CV Value</Col>
            </Row>
            {exercises?.length > 0 && exercises.map((exercise, index) => {
                return <MapExercise key={'add-exercise-' + index}
                    index={index}
                    exercise={exercise}
                    handleChangeExerciseName={handleChangeExerciseName}
                    holderFunction={holderFunction}
                    getTitle={getTitle}
                    handleSwitchType={handleSwitchType}
                    handleChangeExerciseReps={handleChangeExerciseReps}
                    handleChangeDistance={handleChangeDistance}
                    handleChangeExerciseTime={handleChangeExerciseTime}
                    handleChangeCVMode={handleChangeCVMode}
                    removeExercise={removeExercise}
                />
            })}
            <button className="green-glow-button" onClick={addExercise} variant="info" style={{ width: '100%', marginTop: '20px' }}>
                <FontAwesomeIcon icon={faPlus} /> Add New Exercise
            </button>
        </m.div>
    )
}

export default AddExercises